import React from 'react'
import styled from 'styled-components'
import Out_Main_contract from '../../Outsourcings/Out_Main_contract'
import { comma, removeComma } from '../../../service/project'
import ProjectHeader from './ProjectHeader'
import { STEP } from '../projectStepManager'

function PaymentView(props) {
    var canViewCurrentNums = props.canViewCurrentNums
    var contract = props.contract
    var exdata = props.exdata
    var safeContract = props.safeContract
    var buttonRender = props.buttonRender
    var showExampleOverlay = props.showExampleOverlay
    var pg = props.pg
    var displayStep = props.displayStep

    var stepTitle =
        displayStep === STEP.DEPOSIT
            ? '선금 납부'
            : displayStep === STEP.MIDDLE
            ? '중도금 납부'
            : displayStep === STEP.FINAL_PAY
            ? '잔금 납부'
            : '납부'

    var title = props.paymentLabel || stepTitle

    var hideHeader = props.hideHeader

    var paymentOnly = props.paymentOnly

    function showPaymentRow(type) {
        if (!paymentOnly) return true

        return paymentOnly === type
    }

    if (canViewCurrentNums) {
        return (
            <ViewRoot>
                {/* <ProjectHeader pg={pg} viewTitle={title} /> */}
                {!hideHeader ? <ProjectHeader pg={pg} viewTitle={title} /> : null}
                <TopSection>
                    <Out_Main_contract
                        contract={canViewCurrentNums && contract && contract.uid !== 'exampledata' ? contract : exdata}
                    />
                </TopSection>

                {/* <RightTitle>결제 내용 정보</RightTitle> */}

                <ContentSection>
                    <div className="flex c">
                        <div className="money_top w100 mt40">
                            <div className="money_top_table">
                                {/* <div className="intitle">납부</div> */}
                                <div className="intitle">{title}</div>

                                <div className="money_title mt10 mb10 flex">
                                    <div className="p10 w100px">계 약 명:</div>
                                    <div className="p10 w_100px">{safeContract.title}</div>
                                </div>

                                {/* <div className="out_cell p0"> */}
                                <div className="out_cell p0 payment_table">
                                    <div className="flex j a cell_line cell_head">
                                        <div className="w25 p10">구분</div>
                                        <div className="w25 p10">지급금액(VAT포함)</div>
                                        <div className="w50 p10">처리 상태</div>
                                    </div>

                                    {/* <div className="flex j a cell_line">
                                        <div className="w25 p10">선금</div>
                                        <div className="w25 p10">
                                            {comma(
                                                Math.floor(
                                                    ((Number(removeComma(safeContract.allprice || 0)) *
                                                        Number(safeContract.beforeprice || 0)) /
                                                        100) *
                                                        1.1,
                                                ),
                                            )}
                                            원
                                        </div>
                                        <div className="w50 p10 flex a">{buttonRender('선금', 1)}</div>
                                    </div> */}
                                    {showPaymentRow('deposit') ? (
                                        <div className="flex j a cell_line">
                                            <div className="w25 p10">선금</div>
                                            <div className="w25 p10">
                                                {comma(
                                                    Math.floor(
                                                        ((Number(removeComma(safeContract.allprice || 0)) *
                                                            Number(safeContract.beforeprice || 0)) /
                                                            100) *
                                                            1.1,
                                                    ),
                                                )}
                                                원
                                            </div>
                                            <div className="w50 p10 flex a">{buttonRender('선금', 1)}</div>
                                        </div>
                                    ) : null}

                                    {/* <div id="middle-payment-row" className="flex j a cell_line">
                                        <div className="w25 p10">중도금</div>
                                        <div className="w25 p10">
                                            {comma(
                                                Math.floor(
                                                    ((Number(removeComma(safeContract.allprice || 0)) *
                                                        Number(safeContract.middleprice || 0)) /
                                                        100) *
                                                        1.1,
                                                ),
                                            )}
                                            원
                                        </div>
                                        <div className="w50 p10 flex a">{buttonRender('중도금', 2)}</div>
                                    </div> */}

                                    {showPaymentRow('middle') ? (
                                        <div id="middle-payment-row" className="flex j a cell_line">
                                            <div className="w25 p10">중도금</div>
                                            <div className="w25 p10">
                                                {comma(
                                                    Math.floor(
                                                        ((Number(removeComma(safeContract.allprice || 0)) *
                                                            Number(safeContract.middleprice || 0)) /
                                                            100) *
                                                            1.1,
                                                    ),
                                                )}
                                                원
                                            </div>
                                            <div className="w50 p10 flex a">{buttonRender('중도금', 2)}</div>
                                        </div>
                                    ) : null}

                                    {/* <div id="final-payment-row" className="flex j a cell_line">
                                        <div className="w25 p10">잔금</div>
                                        <div className="w25 p10">
                                            {comma(
                                                Math.floor(
                                                    ((Number(removeComma(safeContract.allprice || 0)) *
                                                        Number(safeContract.afterprice || 0)) /
                                                        100) *
                                                        1.1,
                                                ),
                                            )}
                                            원
                                        </div>
                                        <div className="w50 p10 flex a">{buttonRender('잔금', 3)}</div>
                                    </div> */}

                                    {showPaymentRow('final') ? (
                                        <div id="final-payment-row" className="flex j a cell_line">
                                            <div className="w25 p10">잔금</div>
                                            <div className="w25 p10">
                                                {comma(
                                                    Math.floor(
                                                        ((Number(removeComma(safeContract.allprice || 0)) *
                                                            Number(safeContract.afterprice || 0)) /
                                                            100) *
                                                            1.1,
                                                    ),
                                                )}
                                                원
                                            </div>
                                            <div className="w50 p10 flex a">{buttonRender('잔금', 3)}</div>
                                        </div>
                                    ) : null}
                                </div>
                            </div>
                        </div>
                    </div>
                </ContentSection>
            </ViewRoot>
        )
    }

    return (
        <ViewRoot>
            <ProjectHeader pg={pg} viewTitle={title} />

            <TopSection>
                <Out_Main_contract
                    contract={canViewCurrentNums && contract && contract.uid !== 'exampledata' ? contract : exdata}
                />
            </TopSection>

            <RightTitle>결제 내용 정보</RightTitle>

            <ContentSection>
                <div className="flex c">
                    <div className="money_top w100 mt40">
                        <h1>1. 납부 예시</h1>

                        <div className="money_top_table">
                            <div className="money_title mt10 mb10 flex">
                                <div className="p10 w100px">계 약 명</div>
                                <div className="p10 w_100px">개발 계약서 예시</div>
                            </div>

                            {/* <div className="out_cell p0"> */}
                            <div className="out_cell p0 payment_table">
                                <div className="flex j a cell_line cell_head">
                                    <div className="w25 p10">구분</div>
                                    <div className="w25 p10">지급금액(VAT포함)</div>
                                    <div className="w50 p10">처리 상태</div>
                                </div>

                                <div className="flex j a cell_line">
                                    <div className="w25 p10">선금</div>
                                    <div className="w25 p10">22,000,000원</div>
                                    <div className="w50 p10">계약서 전자서명 후 입력 가능</div>
                                </div>

                                <div className="flex j a cell_line">
                                    <div className="w25 p10">중도금</div>
                                    <div className="w25 p10">22,000,000원</div>
                                    <div className="w50 p10">1단계 개발 보고서 승인 후 입력 가능</div>
                                </div>

                                <div className="flex j a cell_line">
                                    <div className="w25 p10">잔금</div>
                                    <div className="w25 p10">11,000,000원</div>
                                    <div className="w50 p10">2, 3단계 개발 보고서 승인 후 입력 가능</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </ContentSection>

            {showExampleOverlay ? <div className="text_absolute">납부 예시입니다</div> : ''}
        </ViewRoot>
    )
}

export default PaymentView

const ViewRoot = styled.div`
    width: 100%;
`

const TopSection = styled.div`
    margin-top: 0;
    padding: 0;
`

const RightTitle = styled.div`
    margin-top: 24px;
`

// const ContentSection = styled.div`
//     margin-top: 8px;
// `
const ContentSection = styled.div`
    margin-top: 8px;

    .payment_table .cell_line {
        display: grid !important;
        grid-template-columns: 25% 25% 50%;
        align-items: stretch !important;
    }

    .payment_table .cell_line > div {
        width: auto !important;
        min-height: 100%;
        height: auto;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        border-right: none !important;
    }

    .payment_table .cell_line > div:nth-child(2),
    .payment_table .cell_line > div:nth-child(3) {
        border-left: 1px solid #d9d9d9;
    }
`
